module.exports = __webpack_public_path__ + "static/media/tag-name-bg.59bfcc82.svg";